import { KeyValueStore } from './key-value-store.js';
import { getGlobalThis } from './global-this.js';
export class UniversalMemoryStorage {
    constructor(id) {
        const storeSymbol = Symbol.for(`${UniversalMemoryStorage.ID}-${id}`);
        const win = getGlobalThis();
        win[storeSymbol] = win[storeSymbol] || new KeyValueStore();
        this.globalStore = win[storeSymbol];
    }
    getStore() {
        if (!this.asyncLocalStorage)
            return this.globalStore;
        const asyncStore = this.asyncLocalStorage.getStore();
        if (asyncStore)
            return asyncStore;
        throw new Error(`UniversalMemoryStorage: 'AsyncLocalStorage' is being used outside of 'runWithSSRContext'`);
    }
    useAsyncLocalStorage(storage) {
        this.asyncLocalStorage = storage;
    }
    switchBackToGlobalStore() {
        delete this.asyncLocalStorage;
    }
    isUsingAsyncStorage() {
        return !!this.asyncLocalStorage;
    }
    get(key) {
        const store = this.getStore();
        return store.get(key);
    }
    has(key) {
        const store = this.getStore();
        return typeof store.get(key) !== 'undefined';
    }
    set(key, value) {
        const store = this.getStore();
        store.set(key, value);
    }
    remove(key) {
        const store = this.getStore();
        store.remove(key);
    }
}
UniversalMemoryStorage.ID = 'crystal-universal-storage';
//# sourceMappingURL=universal-memory-storage.js.map